import React from "react";
import FishingMap from "./FishingMap";

function App() {
  return (
    <div className="App">
      <FishingMap />
    </div>
  );
}

export default App;
